<template>
    <div>
        <!--面包屑-->
        <p class="breadcrumb">MANAGE TRIP</p>
        <!--上方操作框-->
        <el-row type="flex" class="row-bg p-10 mt-10 bg-lightgarg" justify="space-between">
            <el-col :span="24" class="text-right">
                <div class="grid-content">
                    <el-button type="success" @click="CreatTripdialog = true" icon="el-icon-plus">New Trip</el-button>
                </div>
            </el-col>
        </el-row>
        <!--下方表格-->
        <el-table empty-text="No data" v-loading="loading" element-loading-text="loading..." :data="TripData" border style="width: 100%" class="mt-20">
            <el-table-column prop="name" label="Name"></el-table-column>
            <!-- <el-table-column prop="teacher" label="Teacher Edit Enabled" width="180" align="center">
              <template slot-scope="scope">
                <el-switch
                    v-model="scope.row.teacherEditEnabled"
                    @change="editTeacherEnable(scope.row)"
                    active-color="#13ce66"
                    inactive-color="#ff4949">
                </el-switch>
              </template>
            </el-table-column> -->
            <el-table-column prop="saEditEnabled" label="SA Edit Enabled" width="180" align="center">
                <template slot-scope="scope">
                  <el-switch
                      v-model="scope.row.saEditEnabled"
                      @change="editSaEnable(scope.row)"
                      active-color="#13ce66"
                      inactive-color="#ff4949">
                  </el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="taEditEnabled" label="TA Edit Enabled" width="180" align="center">
                <template slot-scope="scope">
                  <el-switch
                      v-model="scope.row.taEditEnabled"
                      @change="editTaEnable(scope.row)"
                      active-color="#13ce66"
                      inactive-color="#ff4949">
                  </el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="student" label="Student Edit Enabled" width="180" align="center">
              <template slot-scope="scope">
                <el-switch
                    v-model="scope.row.studentEditEnabled"
                    @change="editStudentEnable(scope.row)"
                    active-color="#13ce66"
                    inactive-color="#ff4949">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="action" label="Actions" width="130" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" icon="el-icon-edit" @click="EditTrip(scope.row)"></el-button>
                    <el-button type="danger" size="mini" icon="el-icon-delete" @click="DeleteTrip(scope.row)"></el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--新建trip-->
        <el-dialog title="Create Trip" :visible.sync="CreatTripdialog" customClass="dialogStyle">
            <el-form :model="Newform" :rules="newrules" ref="Newform" @submit.native.prevent>
                <el-form-item label="Trip Name" prop="NewName" :label-width="formLabelWidth">
                    <div class="el-input"><!--键盘事件只能绑定在button 上，故将el－input拆分-->
                        <input class="el-input__inner" v-model="Newform.NewName" placeholder="Trip Name" auto-complete="off" v-on:keyup.enter="NewTrip('Newform')"/>
                    </div>
                </el-form-item>
                <el-form-item label="Trip Tips" :label-width="formLabelWidth">
                    <el-input v-model="Newform.tips"></el-input>
                </el-form-item>
                <el-form-item label="period of Tips" :label-width="formLabelWidth">
                    <el-date-picker
                        v-model="Newform.date"
                        type="daterange"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        range-separator="to"
                        start-placeholder="start"
                        end-placeholder="end"
                        :picker-options="endPickerOptions0"
                        >
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="CreatTripdialog = false">Close</el-button>
                <el-button type="primary" :loading="saving" @click="NewTrip('Newform')">Save</el-button>
            </div>
        </el-dialog>

        <!--修改trip-->
        <el-dialog title="Edit Trip" :visible.sync="EditTripdialog" customClass="dialogStyle">
            <el-form :model="Editform" :rules="editrules" ref="Editform" @submit.native.prevent>
                <el-form-item label="Trip Name" prop="EditName" :label-width="formLabelWidth">
                    <el-input v-model="Editform.EditName" prop="EditName" placeholder="Trip Name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="Trip Tips" prop="tips" :label-width="formLabelWidth">
                    <el-input v-model="Editform.tips"></el-input>
                </el-form-item>
                <el-form-item label="period of Tips" prop="date" :label-width="formLabelWidth">
                    <el-date-picker
                        v-model="Editform.date"
                        type="daterange"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        range-separator="to"
                        start-placeholder="start"
                        end-placeholder="end"
                        :picker-options="endPickerOptions0"
                        >
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="EditTripdialog = false">Close</el-button>
                <el-button type="primary" :loading="saving" @click="submitedit('Editform')">Save</el-button>
            </div>
        </el-dialog>

        <!--分页符-->
        <div class="text-center mt-20 mb-50">
            <el-pagination layout="prev, pager, next" :page-size="size" :current-page="currentPage" :page-count="totalPages"
                           @current-change="pageCurrentChange">
            </el-pagination>
        </div>

    </div>
</template>
<script>
    export default {
        data() {
            return {
                TripData: [],//列表信息
                currentPage: 1,
                size: 15,
                totalPages: 1,
                loading: true,

                CreatTripdialog: false,
                EditTripdialog: false,
                Newform: {},
                Editform: {},
                //弹窗规则
                newrules: {
                    NewName: [
                        {required: true, message: 'Trip Name Required', trigger: 'blur'},
                        {max: 255, message:'Trip name cannot be longer than 255 characters', trigger: 'blur'}
                    ],
                },
                editrules: {
                    EditName: [
                        {required: true, message: 'Trip Name Required', trigger: 'blur'},
                        {max: 255, message:'Trip name cannot be longer than 255 characters', trigger: 'blur'}
                    ],
                },
                id:0,//修改trip 传id
                deleteName:'',//删除trip
                formLabelWidth: '130px',
                saving:false,
                endPickerOptions0: {
                    disabledDate(time) {
                    let timeSpace = time.getTime() < Date.now() - 8.64e7;
                    return timeSpace;
                    }
                },
            }
        },
        mounted: function () {
            this.$nextTick(function () {
                this.getTrip();
            })
        },
        methods: {
            // editTeacherEnable(trip) {
            //   this.$http.get(`/trip/teacherEnabled/${trip.id}?enabled=${trip.teacherEditEnabled}`).catch(error=> {
            //     this.$message.error(error.message);
            //   })
            // },
            editTaEnable(trip) {
            this.$http.get(`/trip/taEnabled/${trip.id}?enabled=${trip.taEditEnabled}`).catch(error=> {
                this.$message.error(error.message);
              })
            },
            editSaEnable(trip) {
            this.$http.get(`/trip/saEnabled/${trip.id}?enabled=${trip.saEditEnabled}`).catch(error=> {
                this.$message.error(error.message);
              })
            },
            editStudentEnable(trip) {
              this.$http.get(`/trip/studentEnabled/${trip.id}?enabled=${trip.studentEditEnabled}`).catch(error=> {
                this.$message.error(error.message);
              })
            },
            handleIconClick() {
                this.getTrip();
            },

            //新建trip
            NewTrip(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.saving = true;
                        console.log(this.Newform,"formform")
                        let param = {
                            name:this.Newform.NewName,
                            tips:this.Newform.tips || ''
                        }
                        if(this.Newform.date && this.Newform.date.length > 0){
                            param.startDate = this.Newform.date[0]
                            param.endDate = this.Newform.date[1]
                        }else{
                            param.startDate = ''
                            param.endDate = ''
                        }
                        console.log(param,"参数")
                        this.$http.post('trip', param).then((response) => {
                            //渲染数据
                            this.getTrip();
                            this.Newform = {};
                            this.CreatTripdialog = false;
                            this.loading = false;
                            this.saving = false;
                            this.$message.success('New trip created.');
                        }).catch(error => {
                            this.CreatTripdialog = false;
                            this.loading = false;
                            this.saving = false;
                            this.$message.error(error.message)
                        })
                    }
                })
            },


            //获取弹窗信息
            EditTrip(trip){
                this.id = trip.id;
                this.deleteName = trip.name;
                this.$set(this.Editform,'EditName',trip.name)
                this.$set(this.Editform,'tips',trip.tips)
                var arr = []
                if(trip.startDate && trip.startDate !== ''){
                    arr.push(trip.startDate)
                    arr.push(trip.endDate)
                }
                this.$set(this.Editform,'date',arr)
                console.log(this.Editform,"编辑表单")
                console.log(this.deleteName,"编辑表单")
                this.EditTripdialog = true;
            },

            //编辑trip
            submitedit(formName) {
                // if(this.deleteName != this.Editform.EditName){
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            this.saving = true;
                            let param = {
                                id: this.id,
                                name: this.Editform.EditName,
                                tips:this.Editform.tips,
                            }
                            if(this.Editform.date && this.Editform.date.length > 0){
                                param.startDate = this.Editform.date[0]
                                param.endDate = this.Editform.date[1]
                            }else{
                                param.startDate = ''
                                param.endDate = ''
                            }
                            console.log(param,"canshu")
                            this.$http.put('trip', param).then(response => {
                                this.EditTripdialog = false;
                                this.saving = false;
                                this.loading = true;
                                this.getTrip();
                                this.loading = false;
                            }).catch(error => {
                                this.saving = false;
                                this.loading = false;
                                this.EditTripdialog = false;
                                this.$message.error(error.message)
                            })

                        }
                    });
                // }else {
                //     this.EditTripdialog = false;
                // }

            },

            //删除trip
            DeleteTrip(user){
                this.deleteName = user.name;
                this.$confirm('Are you sure you want to delete trip: ' + this.deleteName, 'Delete Trip', {
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel',
                    confirmButtonClass: 'el-button--danger',
                    type: 'warning',
                    confirmButtonLoading : false,
                    beforeClose: (action, instance, done) => {
                        if (action === 'confirm') {
                            instance.confirmButtonLoading = true;
                            done();
                        } else {
                            instance.confirmButtonLoading = false;
                            done();
                        }
                    }
                }).then(() => {
                    this.$http.delete('trip/' + user.id).then(response => {
                        this.getTrip();
                    }).catch(error => {
                        this.loading = false;
                        this.$message.error(error.message)
                    })
                }).catch(() => {//弹窗点击cancel后执行的方法

                });
            },


            //获取trip列表通用函数
            getTrip(){
                this.loading = true;
                this.$http.get('trip',{params:{page:(this.currentPage-1), size:this.size}}).then(response => {
                    //渲染数据
                    this.loading = false;
                    this.TripData = response.list;
                    this.totalPages = response.totalPages;
                }).catch(error => {
                    this.loading = false;
                    this.$message.error(error.message)
                })
            },

            //改变当前页函数
            pageCurrentChange(val){
                this.currentPage = val;
                console.log(this.currentPage)
                this.getTrip();
            },
        }
    }
</script>
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// Trip.vue?b0f1c228